/* Think Crucial homepage finder: live Shopify predictive search under the model-number input.
   Data: /search/suggest?...&section_id=tc-suggest (sections/tc-suggest.liquid), which adds "fit": the crucial.fits_models or
   crucial.replaces_parts entry equal to the query. "Fits X" is printed only from that, never from a title match. If the
   section request fails, /search/suggest.json is used and no fit label is shown.
   P8 (2026-10-06): the same section also returns data-tc-suggest-meta, the honest no-match result (snippets/tc-sx-match.liquid,
   shared with the header search and the results page). When no result lists the brand / model typed, the readout says so
   ("We don't stock a part for Dyson V8 yet") and shows the results as "Other parts we stock". 10 results are fetched so the
   check sees more than the 4 shown.
   ARIA combobox (1.2): the input owns a listbox of options via aria-activedescendant; DOM focus stays in the input.
   Up/Down move the active option, Enter opens it (or submits the search when none is active), Escape closes.
   Without JS the form still submits to /search?type=product&q=... */
(function () {
  'use strict';
  var form = document.getElementById('tch-finder');
  if (!form) return;
  var input = document.getElementById('tch-q');
  var out = document.getElementById('tch-readout');
  var status = document.getElementById('tch-ro-status');
  var chips = [].slice.call(form.querySelectorAll('.tch-tag'));
  var figModels = [].slice.call(document.querySelectorAll('.tch-fig-model'));
  var LIMIT = 4, FETCH = 10;
  var timer = null, seq = 0, ctrl = null, lastQ = '', dismissed = false, active = -1;
  var check = '<svg viewBox="0 0 96 96" aria-hidden="true" focusable="false"><path d="M20 50 L40 70 L76 28" fill="none" stroke="#243844" stroke-width="12" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(v) {
    var n = Number(v);
    if (!isFinite(n)) return '';
    return '$' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function searchUrl(q) { return '/search?q=' + encodeURIComponent(q) + '&type=product'; }
  function highlight(title, q) {
    var i = title.toLowerCase().indexOf(q.toLowerCase());
    if (i < 0) return { html: esc(title), literal: false };
    return { html: esc(title.slice(0, i)) + '<mark>' + esc(title.slice(i, i + q.length)) + '</mark>' + esc(title.slice(i + q.length)), literal: true };
  }
  function setFig(q) {
    figModels.forEach(function (t) {
      t.textContent = q ? q.toUpperCase().slice(0, 12) : 'AD3000';
      t.setAttribute('opacity', q ? '1' : '.55');
    });
  }
  function markChips(q) {
    chips.forEach(function (c) { c.classList.toggle('is-on', c.getAttribute('data-q').toUpperCase() === q.toUpperCase()); });
  }
  function opts() { return [].slice.call(out.querySelectorAll('[role="option"]')); }
  function setActive(i) {
    var l = opts();
    active = (i >= 0 && i < l.length) ? i : -1;
    l.forEach(function (o, k) { o.setAttribute('aria-selected', k === active ? 'true' : 'false'); o.classList.toggle('is-active', k === active); });
    if (active > -1) { input.setAttribute('aria-activedescendant', l[active].id); if (l[active].scrollIntoView) l[active].scrollIntoView({ block: 'nearest' }); }
    else input.removeAttribute('aria-activedescendant');
  }
  function expanded(on) { input.setAttribute('aria-expanded', on && opts().length ? 'true' : 'false'); }
  function say(msg) { if (!status) return; status.textContent = ''; setTimeout(function () { status.textContent = msg; }, 60); }
  function open() { dismissed = false; out.classList.add('is-open'); expanded(true); }
  function close(clear) {
    out.classList.remove('is-open');
    setActive(-1);
    expanded(false);
    if (clear) out.innerHTML = '';
  }
  function head(q, label) {
    return '<div class="tch-ro__head"><span>Readout</span><b>' + esc(q.toUpperCase()) + '</b><span>' + label + '</span>' +
      '<button type="button" class="tch-ro__close" data-tch-close aria-label="Close matching parts">Close &times;</button></div>';
  }
  function honest(m, q) {
    if (!m || (m.state !== 'none' && m.state !== 'soldout') || !m.label) return '';
    var ask = '<a href="' + esc(searchUrl(q)) + '#tcx-ask">ask us with your model number</a>';
    if (m.state === 'soldout') return '<p class="tch-ro__empty tch-ro__nm">Our part for <b>' + esc(m.label) + '</b> is sold out right now. <a href="' + esc(m.url) + '">See it</a>, or ' + ask + '.</p>';
    var what = m.kind === 'type' ? (/^[aio]/i.test(m.label) || /^e(?!u)/i.test(m.label) ? 'an' : 'a') + ' <b>' + esc(m.label) + '</b>' : 'a part for <b>' + esc(m.label) + '</b>';
    return '<p class="tch-ro__empty tch-ro__nm">We don&rsquo;t stock ' + what + ' yet. Check the model number on the label (<a href="/pages/model-number">where to find it</a>), or ' + ask + '.</p>';
  }
  function render(q, products, cents, meta) {
    var html, label, nm = honest(meta, q);
    if (!products.length) {
      label = 'No match';
      html = head(q, label) + (nm || '<p class="tch-ro__empty">No exact match. Check the model number on the label, or <a href="/pages/model-number">find your model number</a>.</p>');
    } else {
      label = nm ? 'No exact match' : (products.length < LIMIT ? products.length + (products.length === 1 ? ' match' : ' matches') : 'Top ' + LIMIT + ' matches');
      html = head(q, label) + nm + (nm ? '<p class="tch-ro__sub">Other parts we stock</p>' : '') + '<ul class="tch-ro__list" id="tch-ro-list" role="listbox" aria-label="' + (nm ? 'Other parts we stock' : 'Matching parts') + '">' + products.map(function (p, i) {
        var h = highlight(p.title || '', q);
        var img = (p.featured_image && p.featured_image.url) || p.image || '';
        if (img && !cents) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=128';
        var pr = function (v) { return cents ? Number(v) / 100 : v; };
        var varies = p.price_min && p.price_max && Number(p.price_min) !== Number(p.price_max);
        var meta = '';
        if (p.fit) meta += '<span class="tch-fits">' + check + 'Fits ' + esc(p.fit) + '</span>';
        if (p.available === false) meta += '<span class="tch-ro__oos">Sold out</span>';
        return '<li class="tch-ro__opt" role="option" id="tch-ro-o' + i + '" aria-selected="false" data-href="' + esc(p.url || '#') + '"><span class="tch-ro__item">' +
          '<span class="tch-ro__thumb">' + (img ? '<img src="' + esc(img) + '" alt="" width="64" height="64" loading="lazy">' : '') + '</span>' +
          '<span><span class="tch-ro__t">' + h.html + '</span>' + (meta ? '<span class="tch-ro__meta">' + meta + '</span>' : '') + '</span>' +
          '<span class="tch-ro__price">' + (varies ? '<small>From</small>' : '') + esc(money(pr(varies ? p.price_min : p.price))) + '</span></span></li>';
      }).join('') + '</ul>' +
        '<div class="tch-ro__foot"><a href="' + esc(searchUrl(q)) + '">See all results for &ldquo;' + esc(q) + '&rdquo; <span aria-hidden="true">&rarr;</span></a>' +
        '<span><svg width="14" height="14" aria-hidden="true" focusable="false"><use href="#tch-i-check"/></svg>Fit guaranteed</span></div>';
    }
    out.innerHTML = html;
    active = -1;
    input.removeAttribute('aria-activedescendant');
    open();
    say(nm ? (meta.state === 'soldout' ? 'Our part for ' + meta.label + ' is sold out. ' : 'We don’t stock a part for ' + meta.label + ' yet. ') + (products.length ? products.length + ' other parts listed.' : '')
      : (products.length ? label + ' for ' + q + '. Use the up and down arrows to choose one.' : 'No exact match for ' + q + '.'));
  }
  function fail(q) {
    out.innerHTML = head(q, 'Offline') + '<p class="tch-ro__empty">Live matching isn&rsquo;t available right now. Press Find my part to see every result for &ldquo;' + esc(q) + '&rdquo;.</p>';
    open();
    say('Live matching is not available. Press Find my part to search.');
  }
  function run(raw) {
    var q = raw.trim();
    setFig(q);
    markChips(q);
    if (q.length < 2) { lastQ = ''; close(true); return; }
    if (q === lastQ && out.innerHTML) { open(); return; }
    lastQ = q;
    var my = ++seq;
    if (ctrl && ctrl.abort) ctrl.abort();
    ctrl = window.AbortController ? new AbortController() : null;
    out.setAttribute('aria-busy', 'true');
    var hb = out.querySelector('.tch-ro__head b'), hl = out.querySelector('.tch-ro__head span:last-of-type');
    if (hb && hl) { hb.textContent = q.toUpperCase(); hl.textContent = 'Searching\u2026'; }
    var qs = 'q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=' + FETCH;
    var sig = ctrl ? ctrl.signal : undefined;
    var viaSection = fetch('/search/suggest?' + qs + '&section_id=tc-suggest', { credentials: 'same-origin', signal: sig })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (t) {
        var m = t.match(/<script type="application\/json" data-tc-suggest>([\s\S]*?)<\/script>/);
        var mm = t.match(/<script type="application\/json" data-tc-suggest-meta>([\s\S]*?)<\/script>/);
        if (!m) throw new Error('no data');
        return { ps: JSON.parse(m[1]), cents: true, meta: mm ? JSON.parse(mm[1]) : null };
      });
    viaSection
      .catch(function (e) {
        if (e && e.name === 'AbortError') throw e;
        return fetch('/search/suggest.json?' + qs, { credentials: 'same-origin', headers: { Accept: 'application/json' }, signal: sig })
          .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
          .then(function (d) {
            var ps = ((d && d.resources && d.resources.results && d.resources.results.products) || []).map(function (p) { p.fit = ''; return p; });
            return { ps: ps, cents: false };
          });
      })
      .then(function (res) {
        if (my !== seq) return;
        render(q, res.ps.slice(0, LIMIT), res.cents, res.meta);
      })
      .catch(function (e) { if (my !== seq || (e && e.name === 'AbortError')) return; lastQ = ''; fail(q); })
      .then(function () { if (my === seq) out.removeAttribute('aria-busy'); });
  }
  function go(o) { var h = o && o.getAttribute('data-href'); if (h && h !== '#') window.location.href = h; }

  input.addEventListener('input', function () {
    dismissed = false;
    clearTimeout(timer);
    var v = input.value;
    timer = setTimeout(function () { run(v); }, 220);
  });
  input.addEventListener('focus', function () { if (!dismissed && out.innerHTML && input.value.trim().length >= 2) open(); });
  input.addEventListener('keydown', function (e) {
    var l = opts();
    if (e.key === 'ArrowDown' || e.key === 'Down') {
      if (!l.length) return;
      e.preventDefault();
      if (!out.classList.contains('is-open')) { open(); }
      setActive(active < l.length - 1 ? active + 1 : active);
    } else if (e.key === 'ArrowUp' || e.key === 'Up') {
      if (!l.length || !out.classList.contains('is-open')) return;
      e.preventDefault();
      setActive(active > 0 ? active - 1 : -1);
    } else if (e.key === 'Enter') {
      if (active > -1 && out.classList.contains('is-open') && l[active]) { e.preventDefault(); go(l[active]); }
    } else if (e.key === 'Escape' || e.key === 'Esc') {
      if (out.classList.contains('is-open')) { e.preventDefault(); close(false); dismissed = true; }
    }
  });
  out.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); close(false); dismissed = true; input.focus(); }
  });
  out.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-tch-close]')) { close(false); dismissed = true; input.focus(); return; }
    var o = e.target.closest && e.target.closest('[role="option"]');
    if (o) { go(o); }
  });
  out.addEventListener('mousemove', function (e) {
    var o = e.target.closest && e.target.closest('[role="option"]');
    if (o) { var k = opts().indexOf(o); if (k !== active) setActive(k); }
  });
  form.addEventListener('submit', function (e) {
    var q = input.value.trim();
    if (!q) { e.preventDefault(); input.focus(); return; }
    input.value = q;
  });
  chips.forEach(function (c) {
    c.addEventListener('click', function () {
      clearTimeout(timer);
      input.value = c.getAttribute('data-q');
      run(input.value);
      input.focus({ preventScroll: true });
    });
  });
  document.addEventListener('click', function (e) { if (!form.contains(e.target)) close(false); });
  form.addEventListener('focusout', function (e) {
    if (e.relatedTarget && !form.contains(e.relatedTarget)) close(false);
  });

  var where = document.getElementById('tch-where');
  [].slice.call(document.querySelectorAll('a[href="#tch-where"]')).forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (!where) return;
      e.preventDefault();
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      where.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      where.focus({ preventScroll: true });
    });
  });
})();

/* Home reviews row (index.liquid, #tch-reviews): endless loop. The cards are cloned once before and once after (hidden from
   assistive tech and the tab order) and the scroll position is moved by one set's width when it nears either end, so
   arrows, swipes and the slow auto-advance never run out. Auto-advance stops on hover, focus, touch, off screen, in a hidden
   tab, after Pause (WCAG 2.2.2) and by default under prefers-reduced-motion. */
(function () {
  'use strict';
  var root = document.querySelector('[data-tch-rv]');
  if (!root || !window.requestAnimationFrame) return;
  var vp = root.querySelector('.tch-rv__vp');
  var list = root.querySelector('.tch-rv__list');
  var ctl = root.querySelector('[data-tch-rv-ctl]');
  var playBtn = root.querySelector('[data-tch-rv-play]');
  var items = [].slice.call(list.children);
  if (!vp || !ctl || items.length < 2) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SPEED = 28;
  function cloneSet() {
    var f = document.createDocumentFragment();
    items.forEach(function (li) {
      var c = li.cloneNode(true);
      c.setAttribute('aria-hidden', 'true');
      c.setAttribute('inert', '');
      [].slice.call(c.querySelectorAll('a,button')).forEach(function (a) { a.setAttribute('tabindex', '-1'); });
      f.appendChild(c);
    });
    return f;
  }
  list.insertBefore(cloneSet(), list.firstChild);
  list.appendChild(cloneSet());
  var setW = 0, pos = 0, last = 0, holdUntil = 0, playing = !reduce, hover = false, focus = false, touch = false, onScreen = true, settle = 0;
  function measure() {
    var old = setW;
    setW = items[0].offsetLeft - list.firstElementChild.offsetLeft;
    if (setW === old) return;
    if (!old) { vp.scrollLeft = setW; } else if (setW) { vp.scrollLeft = setW + ((vp.scrollLeft - old) % setW + setW) % setW; }
    pos = vp.scrollLeft;
  }
  function wrap() {
    if (!setW) return;
    if (vp.scrollLeft < setW * 0.5) vp.scrollLeft += setW;
    else if (vp.scrollLeft > setW * 1.5) vp.scrollLeft -= setW;
    pos = vp.scrollLeft;
  }
  function setPlaying(on) {
    playing = on;
    playBtn.textContent = on ? 'Pause' : 'Play';
    playBtn.setAttribute('aria-label', on ? 'Pause the moving reviews' : 'Play the moving reviews');
  }
  function tick(now) {
    var dt = last ? Math.min(now - last, 100) : 0;
    last = now;
    if (!setW) measure();
    if (playing && !hover && !focus && !touch && onScreen && !document.hidden && now > holdUntil && setW) {
      pos += SPEED * dt / 1000;
      if (pos > setW * 1.5) pos -= setW;
      vp.scrollLeft = pos;
    }
    requestAnimationFrame(tick);
  }
  vp.addEventListener('scroll', function () {
    if (Math.abs(vp.scrollLeft - pos) < 2) return;
    pos = vp.scrollLeft;
    clearTimeout(settle);
    settle = setTimeout(wrap, 150);
  }, { passive: true });
  root.addEventListener('mouseenter', function () { hover = true; });
  root.addEventListener('mouseleave', function () { hover = false; });
  root.addEventListener('focusin', function () { focus = true; });
  root.addEventListener('focusout', function (e) { if (!e.relatedTarget || !root.contains(e.relatedTarget)) focus = false; });
  vp.addEventListener('touchstart', function () { touch = true; }, { passive: true });
  vp.addEventListener('touchend', function () { touch = false; holdUntil = performance.now() + 3000; }, { passive: true });
  [].slice.call(ctl.querySelectorAll('[data-tch-rv-dir]')).forEach(function (b) {
    b.addEventListener('click', function () {
      var step = items[1].offsetLeft - items[0].offsetLeft;
      holdUntil = performance.now() + 4000;
      vp.scrollBy({ left: (+b.getAttribute('data-tch-rv-dir')) * step, behavior: reduce ? 'auto' : 'smooth' });
    });
  });
  playBtn.addEventListener('click', function () { setPlaying(!playing); });
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (es) { onScreen = es[0].isIntersecting; }).observe(vp);
  }
  if ('ResizeObserver' in window) new ResizeObserver(function () { measure(); }).observe(list);
  else window.addEventListener('resize', function () { measure(); });
  ctl.hidden = false;
  setPlaying(playing);
  measure();
  requestAnimationFrame(tick);
})();
